export default defineNuxtRouteMiddleware((to) => {
  const token = useCookie('token')
  const localePath = useLocalePath()

  if (token.value) {
    if (to.query && Object.keys(to.query).length > 0) {
      const hasEverflowParams = to.query.oid || to.query.affid || to.query.sub1
      
      if (hasEverflowParams && typeof window !== 'undefined') {
        const mainStore = useMainStore()
        const params = new URLSearchParams(to.query as Record<string, string>)
        params.delete('token')
        if (params.toString()) {
          mainStore.setUtmParams(params.toString())
        }
      }
    }
    
    const currentQuery: Record<string, any> = {
      paywall_force: (to.query.paywall_force === 'false' || to.query.paywall_force === false) ? 'false' : 'true',
    }

    return navigateTo({
      path: localePath('/'),
      query: currentQuery
    })
  }
})
